<template lang="pug">
.d-flex
  .flex-grow-1
    filter-name.mr-2(:filter.sync="nameFilter")
    filter-quantity.mr-2(:filter.sync="totalItemFilter" title="Total item" param="total_item" placeholder="Enter quantity")
    filter-date.mr-2(:filter.sync="createdDateFilter" title="Created date" param="created_date")
  v-btn.button-sm.underline.px-0(text :disabled="allFilters.length === 0" @click="resetFilters") Reset filters
</template>

<script>
import FilterName from '@/components/module/filter/FilterName.vue'
import FilterQuantity from '@/components/module/filter/FilterQuantity.vue'
import FilterDate from '@/components/module/filter/FilterDate.vue'

export default {
  components: { 
    FilterName, FilterDate, FilterQuantity
  },
  props: ['filters'],
  data: () => ({
    key: 0,
    nameFilter: {},
    totalItemFilter: {},
    createdDateFilter: {},
  }),
  watch: {
    allFilters (newValue) {
      this.$emit('update:filters', newValue)
    }
  },
  computed: {
    allFilters () {
      const filters = []
      if (this.nameFilter.key) {
        filters.push(this.nameFilter)
      }
      if (this.totalItemFilter.key) {
        if (this.totalItemFilter.key === 'between') {
          const values = this.totalItemFilter.value
          for (const i in values) {
            filters.push(values[i])
          }
        } else {
          filters.push(this.totalItemFilter)
        }
      }
      if (this.createdDateFilter.key) {
        if (this.createdDateFilter.key === 'between') {
          const values = this.createdDateFilter.value
          for (const i in values) {
            filters.push(values[i])
          }
        } else {
          filters.push(this.createdDateFilter)
        }
      }
      return filters
    }
  },
  methods: {
    resetFilters () {
      this.nameFilter = {}
      this.totalItemFilter = {}
      this.createdDateFilter = {}
    },
  }
}
</script>